import React from 'react'
import { Col, Collapse, Row, Modal, Icon, Tooltip } from "antd";
import { connect } from 'react-redux'
import PropTypes from 'prop-types'

// Components
import Container from "../../../containers/Container";
import Api_tnn from "../../../api/api.tnn";
import Message from "../../../components/Messages";
import message from "../../../components/Messages";
import MESSAGE from "../../../components/Messages";
import helper from '../../../helper/helper'
import typo from '../../../constants/dictionaries'
import columns from './BCDK.column'
import Table from '../../../components/Table'
import Api_quantrac from "../../../api/api.quantrac";
import Api_dms from "../../../api/api.dms";
import BCDKModal from '../BaoCaoDinhKy/Modal/index'
import { isEmpty } from 'lodash'
import { functionsCode } from '../../../constants/constant'
import Button from "../../../components/Buttons";

const { Panel } = Collapse;

class BaoCaoDK extends React.Component {
    constructor(props) {
        super(props);
        const { functions } = props;
        this.state = {
            data: [],
            mode: 'add',
            isShowEditModal: false,
            isShowAddModal: false,
            selectedRow: null,
            pagination: {
                PageNumber: 1,
                PageSize: 10,
                Total: 0
            },
        }
    }

    componentDidMount() {
        const { idGiayPhep } = this.props;
        const { pagination } = this.state
        idGiayPhep && this.getBCDKbyID(pagination.PageNumber, pagination.PageSize)
    }  

    getBCDKbyID = (page, size) => {
        const { idGiayPhep, apiGetBCDK_by_QD } = this.props;
        apiGetBCDK_by_QD({ token: this.props.user.access_token, thongtinchung_id: idGiayPhep, page: page, size: size })
            .then(res => {
                this.setState({
                    data: res && res.data,
                    pagination: {
                        PageNumber: res && res.pagination && res.pagination.currentPage,
                        PageSize: size,
                        Total: res && res.pagination && res.pagination.total
                    },
                })
            })
            .catch(err => {
                Message.error(err.message)
            })
    };

    componentDidUpdate(prevProps, prevState, snapshot) {
        const { pagination } = this.state
        if (prevProps.idGiayPhep !== this.props.idGiayPhep) {
            this.getBCDKbyID(pagination.PageNumber, pagination.PageSize)
        }
    }
    showEditModal = (selectedRow, name) => {
        this.setState({ mode: name })
        this.GetBCDK_by_ID(selectedRow.id)
    };
    GetBCDK_by_ID = (id) => {
        const {apiGetBCDK_by_ID} = this.props
        apiGetBCDK_by_ID({
                token: this.props.user.access_token,
                id: id,
            })
            .then((res) => {
                this.setState({
                    isShowEditModal: true,
                    selectedRow: res,
                });
            }).catch(err => {
                message.error(err.message)
            });
    };


    showFile = (item) => {
        if (item.files_BCDK !== undefined || item.files_BCDK !== []) {
            if (item.files_BCDK.length > 1) {
                this.setState({
                    setModal: true,
                    selectdFile: item.files_BCDK
                })
            } else {
                this.downFile(item.files_BCDK[0])
            }
        }
    }
    downFile = (data) => {
        if (data === undefined || data === []) {
            message.warning(MESSAGE.CSCORE_KHONG_CO_FILE)
        } else {
            new Api_dms().DownloadFile({
                token: this.props.user.access_token,
                data: { oid: data.idFile, filename: data.tenTaiLieu }
            })
        }
    }
    handleCancel = () => {
        this.setState({
            isShowEditModal: false,
            isShowAddModal: false
        });
    };
    DeleteDoanhNgiep_BaoCao = (id) => {
        const {pagination} =this.state
        const {apiDeleteBCDK} = this.props
        apiDeleteBCDK({
            token: this.props.user.access_token,
            id: id,
          })
          .then(res => {
            message.success("Xóa thành công");
            this.getBCDKbyID(pagination.PageNumber, pagination.PageSize)
          }).catch(err => {
            message.error(err.message)
          });
      };

    showDeleteConfirm = (selectedRow) => {
        this.DeleteDoanhNgiep_BaoCao(selectedRow.id)
      }
    handleAdd = () => {
        const { pagination } = this.state
        this.getBCDKbyID(pagination.PageNumber, pagination.PageSize)
        this.handleCancel();
    };
    handleTableParamsChange = (pagination, filteredInfo, sortedInfo) => {
        this.getBCDKbyID(pagination.current, pagination.pageSize)
    };
    showAddModal = () => {
        this.setState({
            isShowAddModal: true,
        });
    };
    render() {
        const { data_giayphep, user, editable, phanloai } = this.props;
        const { data, mode, isShowEditModal, selectedRow, pagination, isShowAddModal } = this.state;
        const tableColumns = columns({
            showEditModal: this.showEditModal,
            showFile: this.showFile,
            showViewModal: this.showEditModal,
            deleteRow: this.showDeleteConfirm,
            editable
        })

        return (
            <Container>
                {editable &&
                <Row type='flex' justify='end' style={{ marginBottom: 10}}>
                    <Tooltip title="Thêm mới" placement="top">
                        <Button type="primary" onClick={this.showAddModal}>
                            <Icon type="plus" />
                        </Button>
                    </Tooltip>
                </Row>}
                {data.length > 0 ?
                    <Table
                        columns={tableColumns}
                        dataSource={helper.addSttToDataSource(data)}
                        onChange={this.handleTableParamsChange}
                        hideTotal="true"
                        pagination={{
                            total: pagination.Total,
                            pageSize: pagination.PageSize,
                            current: pagination.PageNumber
                        }}
                    />
                    : <div style={{ color: "#cfcdcd", textAlign: "center" }}>
                        Không có báo cáo định kỳ
                          </div>
                }
                {isShowEditModal &&
                    <Modal
                        title={mode === "view" ? typo.cscore_thong_tin_chi_tiet : typo.cscore_edit_bao_cao}
                        centered
                        closable={true}
                        visible={isShowEditModal}
                        width="850px"
                        footer={null}
                        onCancel={this.handleCancel}
                        maskClosable={false}
                    >
                        <BCDKModal
                            handleAdd={this.handleAdd}
                            handleCloseModal={this.handleCancel}
                            selectedRow={selectedRow}
                            isEdit={true}
                            user={user}
                            mode={mode}
                            phanloai={phanloai}
                        />
                    </Modal>
                }
                {isShowAddModal &&
                    <Modal
                        title={typo.cscore_add_bao_cao}
                        centered
                        closable={true}
                        visible={isShowAddModal}
                        width="850px"
                        footer={null}
                        onCancel={this.handleCancel}
                        maskClosable={false}
                    >
                        <BCDKModal
                            handleCloseModal={this.handleCancel}
                            handleAdd={this.handleAdd}
                            selectedRow={data_giayphep}
                            user={user}
                            phanloai={phanloai}
                        />
                    </Modal>
                }
            </Container>
        )
    }
}

BaoCaoDK.propTypes = {
    idGiayPhep: PropTypes.string
};


const mapStateToProps = (state) => ({
    user: state.oidc.user
});

export default connect(mapStateToProps)(BaoCaoDK)